import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import axios from 'axios';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { BASE_PATH, SERVICE_ALIAS } from 'constants/constants';
import { useServiceQuery } from 'generated/graphql';
import Categories from 'components/Categories/Categories';
import menuIcon from 'assets/img/hamburger.svg';
import cross from 'assets/img/cross.svg';
import logo from 'assets/img/service-logo@x2.png';

import s from './Header.module.scss';

export interface IMatchParams {
  alias: string;
  id: string;
}

const Header = () => {
  const routeMatch = useRouteMatch<IMatchParams>({
    path: '/:alias/:id',
  });
  const history = useHistory();
  const [showMenu, setShowMenu] = useState(false);
  const [supportText, setSupportText] = useState('');
  const isLaptop = useMediaQuery({ query: '(min-width: 720px)' });

  const toggleMenu = () => {
    setShowMenu((st) => !st);
  };

  const { data } = useServiceQuery({
    variables: {
      lang: ['ru'],
    },
  });

  const categories = data?.point?.service?.categories;
  const redirectToRoot = () => history && history.push('/');

  useEffect(() => {
    setShowMenu(false);
  }, [routeMatch?.params.id]);

  useEffect(() => {
    axios.get(`${BASE_PATH}/text/${SERVICE_ALIAS}/header-support/1`)
      .then((res) => {
        setSupportText(res.data);
      })
      .catch(() => {});
  }, []);

  if (showMenu) {
    const widthWithScroll = document.body.clientWidth;
    document.body.style.overflow = 'hidden';
    const widthWithoutScroll = document.body.clientWidth;
    if (widthWithScroll < widthWithoutScroll) {
      document.body.style.paddingRight = `${(widthWithoutScroll - widthWithScroll).toString()}px`;
    }
  } else {
    document.body.style.overflow = 'unset';
    document.body.style.paddingRight = 'unset';
  }

  return (
    <div className={s.HeaderWrapper}>
      <header className={s.Header}>
        <div className={s.LogoWrapper}>
          {!isLaptop && (
            <button type="button" className={s.menuIcon} onClick={toggleMenu}>
              <img src={showMenu ? cross : menuIcon} alt="" />
            </button>
          )}
          <div className={cx(s.HeaderContainer)}>
            <div className="logo">
              <button type="button" className={s.logoLink} onClick={redirectToRoot}>
                <img className={s.logoImage} src={logo} alt="" />
              </button>
            </div>
            <button type="button" className={s.logoLink} onClick={redirectToRoot}>
              <div className={s.projectName}>
                Кулинария
              </div>
            </button>
          </div>
        </div>
        { supportText && (
        <div
          className={s.supportContact}
          dangerouslySetInnerHTML={{ __html: supportText }}
        />
        )}
      </header>
      { categories && (
        <Categories
          categories={categories}
          showMenu={showMenu}
          setShowMenu={setShowMenu}
        />
      )}
    </div>
  );
};

export default Header;
